// Generator-discovered file route for reports Tier 3 (per-creative within a
// domain — Module P / P10). Reads the `domainId` search param and passes it to
// the component. Component lives in `src/ad/routes/reports.creatives.tsx`.
import { createFileRoute } from '@tanstack/react-router';
import { ReportsCreativesRouteComponent } from '@/ad/routes/reports.creatives';

function parseDomainId(search: Record<string, unknown>): { domainId?: number } {
  const raw = search.domainId;
  const n = typeof raw === 'number' ? raw : Number(raw);
  return Number.isInteger(n) && n > 0 ? { domainId: n } : {};
}

export const Route = createFileRoute('/_authenticated/ad/reports/creatives')({
  validateSearch: parseDomainId,
  component: ReportsCreativesRoute,
});

function ReportsCreativesRoute(): React.ReactElement {
  const { domainId } = Route.useSearch();
  return <ReportsCreativesRouteComponent domainId={domainId} />;
}
